import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type ManualIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const ManualIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: ManualIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Manual'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 6.8L11.5 2H5.5C5.10218 2 4.72064 2.16857 4.43934 2.46863C4.15804 2.76869 4 3.17565 4 3.6V16.4C4 16.8243 4.15804 17.2313 4.43934 17.5314C4.72064 17.8314 5.10218 18 5.5 18H14.5C14.8978 18 15.2794 17.8314 15.5607 17.5314C15.842 17.2313 16 16.8243 16 16.4V6.8ZM11.5 2V6.8H16M13 10.8H7M13 14H7M8.5 7.6H7'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  )
}
